import React, { ReactNode } from 'react';
import { useAppSelector } from '../../store/hooks';

type ThemeProviderProps = {
  children: ReactNode
}

/** Handles the theme depending on the client name from the user's information.
 *  Client name is the name of the platform the user has came from. Eg R2C/SN
*/ 
const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const theme = useAppSelector((state) => state.user.theme); 
  
  if (theme) {
    document.body.setAttribute("data-theme", theme);
  } 
  
  return <>{children}</>
};

export default ThemeProvider;